/* SAEVENTEEN / ARCADE NETWORK V3 — vanilla JS, no React build pipeline required.
   Uses the same authenticated Supabase client and validated RPC wrapper as Connect Four. */
(() => {
  'use strict';
  const TITLES = [
    ['ROOKIE','START HERE',()=>true],
    ['FIRST BLOOD','WIN 1 RANKED MATCH',p=>p.wins>=1],
    ['RUN IT BACK','PLAY 5 RANKED MATCHES',p=>p.played>=5],
    ['HOT HAND','WIN 5 RANKED MATCHES',p=>p.wins>=5],
    ['17 CLUB','WIN 17 RANKED MATCHES',p=>p.wins>=17]
  ];
  const SKINS = [
    ['CLASSIC','DEFAULT DISC FINISH',()=>true],
    ['REDLINE','WIN 3 RANKED MATCHES',p=>p.wins>=3],
    ['ONYX','WIN 10 RANKED MATCHES',p=>p.wins>=10],
    ['GHOST','PLAY 25 RANKED MATCHES',p=>p.played>=25]
  ];
  const AVATARS = ['01','02','03','04','05','06','07','08'];
  const fallbackProfile={username:'GUEST',avatar:'01',title:'ROOKIE',skin:'CLASSIC',wins:0,losses:0,draws:0,played:0,xp:0,rank:null};
  const count = n => (Number(n)||0).toLocaleString();
  const el = (tag,className,text) => {
    const n=document.createElement(tag);
    if(className) n.className=className;
    if(text!==undefined) n.textContent=String(text);
    return n;
  };
  const validError = err => ((err && err.message) || String(err)).slice(0,170);
  function init(root) {
    if(root.dataset.saeCommunityInit || !root.querySelector('[data-sae-social]') || !root.saeArcade) return;
    root.dataset.saeCommunityInit='1';
    const q=sel=>root.querySelector(sel), qa=sel=>Array.from(root.querySelectorAll(sel));
    const api=root.saeArcade;
    const configured=root.dataset.onlineConfigured==='true';
    const profileForm=q('[data-sae-profile-input]');
    const titleSelect=q('[data-sae-title-select]'),skinSelect=q('[data-sae-skin-select]');
    let activeProfile={...fallbackProfile}, pickedAvatar='01', leaderboard=[], refreshTimer=null, working=false, signedInEmail=false;
    const notice=(txt)=> {const n=q('[data-sae-network-message]');if(n)n.textContent=txt;};
    const feedback=(selector,txt)=>{const n=q(selector);if(n)n.textContent=txt;};
    function avatar(code,name='',className='sae-arcade__rank-avatar') {
      const n=el('span',className,AVATARS.includes(code)?code:'17');
      n.dataset.avatar=AVATARS.includes(code)?code:'01';
      n.title=name||('Avatar '+code);
      return n;
    }
    function setProfile(p){
      activeProfile={...fallbackProfile,...p};pickedAvatar=activeProfile.avatar;
      const nm=q('[data-sae-profile-name]');if(nm)nm.textContent=activeProfile.username;
      const av=q('[data-sae-profile-avatar]');if(av){av.textContent=activeProfile.avatar;av.dataset.avatar=activeProfile.avatar;}
      q('[data-sae-profile-title]').textContent=activeProfile.title+' / '+count(activeProfile.xp)+' XP';
      q('[data-sae-my-rank]').textContent=activeProfile.rank ? 'GLOBAL #'+count(activeProfile.rank):'UNRANKED';
      q('[data-sae-global-wins]').textContent=count(activeProfile.wins);
      q('[data-sae-global-played]').textContent=count(activeProfile.played);
      q('[data-sae-global-xp]').textContent=count(activeProfile.xp);
      if(profileForm && document.activeElement!==profileForm)profileForm.value=activeProfile.username;
      const gameName=q('[data-sae-name]');
      if(gameName) gameName.value=activeProfile.username;
      if(titleSelect)titleSelect.value=activeProfile.title;
      if(skinSelect)skinSelect.value=activeProfile.skin;
      root.dataset.saeSkin=activeProfile.skin.toLowerCase();
      qa('[data-sae-avatar-choice]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.saeAvatarChoice===pickedAvatar)));
      TITLES.forEach(([name,,okay])=>{const op=Array.from(titleSelect.options).find(x=>x.value===name);if(op)op.disabled=!okay(activeProfile);});
      SKINS.forEach(([name,,okay])=>{const op=Array.from(skinSelect.options).find(x=>x.value===name);if(op)op.disabled=!okay(activeProfile);});
      drawUnlocks();
    }
    function drawUnlocks(){
      const target=q('[data-sae-unlocks]');if(!target)return;
      target.replaceChildren();
      let unlocked=0;
      const rewards=[...TITLES.map(x=>[...x,'TITLE']),...SKINS.slice(1).map(x=>[...x,'DISC'])];
      rewards.forEach(([name,requirement,okay,type],i)=>{
        const got=okay(activeProfile);if(got)unlocked++;
        const item=el('div','sae-arcade__unlock'+(got?' is-unlocked':' is-locked'));
        const num=el('small','',String(i+1).padStart(2,'0')+' / '+type);
        const label=el('strong','',name);
        const note=el('span','',got?'UNLOCKED / '+requirement:requirement);
        const mark=el('b','',got?'↗':'×');
        item.append(num,label,note,mark);target.appendChild(item);
      });
      const counter=q('[data-sae-unlock-count]');if(counter)counter.textContent=unlocked+' / '+rewards.length;
    }
    function drawLeaderboard(data){
      const rows=Array.isArray(data.players)?data.players:[];
      leaderboard=rows;
      const target=q('[data-sae-leaderboard]');target.replaceChildren();
      q('[data-sae-total-players]').textContent=count(data.total_players);
      const stack=q('[data-sae-avatars]');stack.replaceChildren();
      rows.slice(0,5).forEach(r=>stack.appendChild(avatar(r.avatar,r.username,'sae-arcade__rank-avatar')));
      if((Number(data.total_players)||0)>5)stack.appendChild(el('span','sae-arcade__stack-extra','+'+count(data.total_players-5)));
      if(!rows.length){target.appendChild(el('p','sae-arcade__empty','NO RANKED GAMES YET. BE THE FIRST.'));return;}
      rows.forEach(r=>{
        const item=el('button','sae-arcade__leader');item.type='button';item.setAttribute('aria-label',`View ${r.username}'s profile`);
        item.append(el('span','sae-arcade__leader-pos',String(r.rank).padStart(2,'0')),avatar(r.avatar,r.username));
        const user=el('span','sae-arcade__leader-user');user.append(el('strong','',r.username),el('small','',r.title));item.appendChild(user);
        const score=el('span','sae-arcade__leader-score');score.append(el('b','',count(r.xp)),el('small','',''));score.querySelector('small').textContent='XP';item.append(score);
        item.addEventListener('click',()=>{
          const detail=q('[data-sae-leader-detail]');detail.hidden=false;detail.replaceChildren();
          detail.append(el('span','',`#${r.rank} / ${r.username} — ${r.title}`),el('strong','',`${count(r.wins)} W / ${count(r.losses)} L / ${count(r.draws)} D  ·  ${count(r.played)} MATCHES`));
        });
        target.appendChild(item);
      });
    }
    function relative(date){
      const ms=Date.now()-new Date(date).getTime();if(!Number.isFinite(ms))return 'RECENT';
      const min=Math.max(0,Math.floor(ms/60000));if(min<1)return 'NOW';if(min<60)return min+'M AGO';
      const hours=Math.floor(min/60);return hours<24?hours+'H AGO':Math.floor(hours/24)+'D AGO';
    }
    function drawActivity(data){
      const target=q('[data-sae-activity]');if(!target)return;
      target.replaceChildren();
      if(!Array.isArray(data)||!data.length){target.append(el('li','sae-arcade__empty','NO RANKED RESULTS YET.'));return;}
      data.forEach((r,i)=>{
        const row=el('li','sae-arcade__feed-event');row.style.setProperty('--item-delay',(i*75)+'ms');
        row.appendChild(avatar(r.avatar,r.username,'sae-arcade__rank-avatar'));
        const body=el('span','sae-arcade__feed-info');
        body.append(el('strong','',r.username),el('small','',r.outcome==='draw'?'PLAYED TO A DRAW':'WON A RANKED MATCH'));
        row.append(body,el('span','sae-arcade__feed-time',relative(r.recorded_at)));
        target.appendChild(row);
      });
    }
    async function fetchSocial(includeProfile=true){
      if(!configured||working) return;
      working=true;notice('UPDATING NETWORK…');
      try{
        if(includeProfile) setProfile(await api.rpc('sae_arcade_profile_get'));
        const results=await Promise.allSettled([api.rpc('sae_arcade_leaderboard',{p_limit:20}),api.rpc('sae_arcade_activity',{p_limit:10})]);
        if(results[0].status==='fulfilled')drawLeaderboard(results[0].value);
        else throw results[0].reason;
        if(results[1].status==='fulfilled')drawActivity(results[1].value);
        notice('NETWORK ONLINE / GLOBAL RANKS');
      }catch(err){notice('NETWORK ERROR / '+validError(err).toUpperCase());}
      finally{working=false;}
    }
    qa('[data-sae-avatar-choice]').forEach(b=>b.addEventListener('click',()=>{
      pickedAvatar=b.dataset.saeAvatarChoice;
      qa('[data-sae-avatar-choice]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));
    }));
    const save=q('[data-sae-save-profile]');
    if(save)save.addEventListener('click',async()=>{
      if(!configured){feedback('[data-sae-profile-feedback]','CONNECT SUPABASE FIRST.');return;}
      save.disabled=true;feedback('[data-sae-profile-feedback]','SAVING…');
      try{
        const p=await api.rpc('sae_arcade_profile_save',{
          p_username:profileForm.value.trim(),p_avatar:pickedAvatar,
          p_title:titleSelect.value,p_skin:skinSelect.value
        });
        setProfile(p);feedback('[data-sae-profile-feedback]','SAVED / YOUR PROFILE IS LIVE');
        await fetchSocial(false);
      }catch(err){feedback('[data-sae-profile-feedback]',validError(err).toUpperCase());}
      finally{save.disabled=false;}
    });
    const reload=q('[data-sae-reload-board]');if(reload)reload.addEventListener('click',()=>fetchSocial());
    const send=q('[data-sae-email-send]'),verify=q('[data-sae-email-verify]');
    if(send) send.addEventListener('click',async()=>{
      const email=(q('[data-sae-email]').value||'').trim();
      if(!/^\S+@\S+\.\S+$/.test(email)){feedback('[data-sae-email-feedback]','ENTER A VALID EMAIL.');return;}
      if(api.state.online && ['playing','waiting'].includes(api.state.online.status)){
        feedback('[data-sae-email-feedback]','LEAVE YOUR ONLINE ROOM BEFORE SWITCHING ACCOUNTS.');return;
      }
      send.disabled=true;feedback('[data-sae-email-feedback]','REQUESTING CODE…');
      try{
        const sb=await api.connect();
        const {error}=await sb.auth.signInWithOtp({email,options:{shouldCreateUser:true}});
        if(error)throw error;
        feedback('[data-sae-email-feedback]','CHECK EMAIL FOR A 6-DIGIT CODE. GUEST RANK DOES NOT TRANSFER.');
      }catch(err){feedback('[data-sae-email-feedback]',validError(err).toUpperCase());}
      finally{send.disabled=false;}
    });
    if(verify)verify.addEventListener('click',async()=>{
      const email=(q('[data-sae-email]').value||'').trim();const token=(q('[data-sae-otp]').value||'').trim();
      if(!/^\d{6,8}$/.test(token)){feedback('[data-sae-email-feedback]','ENTER YOUR EMAIL CODE.');return;}
      if(api.state.online && ['playing','waiting'].includes(api.state.online.status)){
        feedback('[data-sae-email-feedback]','LEAVE YOUR ONLINE ROOM FIRST.');return;
      }
      verify.disabled=true;feedback('[data-sae-email-feedback]','VERIFYING…');
      try{
        const sb=await api.connect();const {error}=await sb.auth.verifyOtp({email,token,type:'email'});
        if(error)throw error;
        await api.connect();
        signedInEmail=true;feedback('[data-sae-email-feedback]','SIGNED IN / PROFILE NOW SYNCED TO THIS EMAIL.');
        await fetchSocial(true);
      }catch(err){feedback('[data-sae-email-feedback]',validError(err).toUpperCase());}
      finally{verify.disabled=false;}
    });
    root.addEventListener('sae:room-updated',e=>{
      if(e.detail && e.detail.status==='finished'){
        // Scores are committed by the PostgreSQL trigger on the server. Refresh after the transaction.
        fetchSocial(true);
      }
    });
    function initGlobe(){
      const cv=q('[data-sae-globe]');if(!cv)return;
      const cx=cv.getContext('2d');if(!cx)return;
      const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
      const points=[[14.5995,120.9842],[19.076,72.8777],[23.8103,90.4125],[30.0444,31.2357],
        [39.9042,116.4074],[-23.5505,-46.6333],[19.4326,-99.1332],[40.7128,-74.006],
        [34.6937,135.5022],[41.0082,28.9784]];
      let spin=0,drag=false,prevX=0,raf=0,visible=true;
      const css=getComputedStyle(root);const line=css.getPropertyValue('--sae-globe-line').trim()||'#62514f';
      const marker=css.getPropertyValue('--sae-globe-marker').trim()||'#a72b28';
      const project=(lat,lon,r)=>{
        const a=lat*Math.PI/180,b=(lon+spin)*Math.PI/180;
        const z=Math.cos(a)*Math.cos(b);
        return [Math.cos(a)*Math.sin(b)*r,-Math.sin(a)*r,z];
      };
      function strokeCurve(coords,r){
        let drawing=false;
        cx.beginPath();
        for(let i=0;i<coords.length;i++){
          const [x,y,z]=project(coords[i][0],coords[i][1],r);
          if(z<=0){drawing=false;continue;}
          if(!drawing){cx.moveTo(x,y);drawing=true;}else cx.lineTo(x,y);
        }
        cx.stroke();
      }
      function frame(){
        if(!cv.isConnected)return;
        if(!visible || document.hidden){raf=requestAnimationFrame(frame);return;}
        const size=Math.max(180,Math.min(cv.clientWidth||340,500));
        const dpr=Math.min(window.devicePixelRatio||1,2);
        if(cv.width!==Math.floor(size*dpr)||cv.height!==Math.floor(size*dpr)){
          cv.width=Math.floor(size*dpr);cv.height=Math.floor(size*dpr);
        }
        cx.setTransform(dpr,0,0,dpr,0,0);cx.clearRect(0,0,size,size);
        cx.save();cx.translate(size/2,size/2);const r=size*.42;
        cx.strokeStyle=line;cx.lineWidth=.85;cx.globalAlpha=.8;
        cx.beginPath();cx.arc(0,0,r,0,Math.PI*2);cx.stroke();
        for(let lat=-60;lat<=60;lat+=30){
          const coords=[];for(let lon=-180;lon<=180;lon+=3)coords.push([lat,lon]);strokeCurve(coords,r);
        }
        for(let lon=0;lon<360;lon+=30){
          const coords=[];for(let lat=-90;lat<=90;lat+=3)coords.push([lat,lon]);strokeCurve(coords,r);
        }
        cx.fillStyle=marker;cx.globalAlpha=1;
        points.forEach(([lat,lon])=>{
          const [x,y,z]=project(lat,lon,r);if(z<0)return;
          cx.beginPath();cx.arc(x,y,Math.max(1.5,size*.006),0,Math.PI*2);cx.fill();
        });
        cx.restore();
        if(!reduced&&!drag)spin=(spin+.18)%360;
        if(!reduced)raf=requestAnimationFrame(frame);
      }
      cv.addEventListener('pointerdown',e=>{drag=true;prevX=e.clientX;cv.setPointerCapture(e.pointerId);});
      cv.addEventListener('pointermove',e=>{if(!drag)return;spin+=(e.clientX-prevX)*.35;prevX=e.clientX;if(reduced)frame();});
      cv.addEventListener('pointerup',()=>{drag=false;});cv.addEventListener('pointercancel',()=>{drag=false;});
      const observer=new IntersectionObserver(entries=>{visible=entries[0]?.isIntersecting??true;},{threshold:0.01});observer.observe(cv);
      root.addEventListener('shopify:section:unload',()=>{cancelAnimationFrame(raf);observer.disconnect();});
      frame();
    }
    initGlobe();
    drawUnlocks();
    if(configured){fetchSocial();refreshTimer=setInterval(()=>{if(!document.hidden)fetchSocial(false);},30000);}
    else {
      notice('SUPABASE REQUIRED / COMPLETE BOTH SQL SETUP FILES');
      const list=q('[data-sae-leaderboard]');if(list)list.textContent='ADD YOUR SUPABASE URL AND PUBLISHABLE KEY IN THE ARCADE SECTION SETTINGS.';
      const act=q('[data-sae-activity]');if(act)act.textContent='ACTIVITY FEED WILL APPEAR WHEN CONNECTED.';
    }
    root.addEventListener('shopify:section:unload',()=>clearInterval(refreshTimer));
  }
  function boot(){document.querySelectorAll('[data-sae-arcade]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();
